import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { Global } from '../classes/Global';
import { StringHelper } from '../helpers/StringHelper';
import { StorageHelper } from '../helpers/StorageHelper';
import { LoginHelper } from '../helpers/LoginHelper';

@Component({
  selector: 'app-apple-redirect',
  templateUrl: './apple-redirect.component.html',
  styleUrls: ['./apple-redirect.component.scss'],
  providers: [ AuthenticationService ]
})
export class AppleRedirectComponent extends BaseComponent implements OnInit {

  errorMessage: string = "";
  showUsernameForm: boolean = false;
  state: any;
  email: string;
  appleUserID: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService
  ) {
    super();
  }

  ngOnInit() {

    this.route.queryParams.subscribe((queryParams: Params) => {
      const base64Data: string = queryParams['data'];
      const data: string = base64Data ? atob(base64Data) : null;

      if(data) {
        const searchParams = this.getQueryParams(data);
        const status = searchParams['status'];
        const decodedState = atob(searchParams['state']);
        if(decodedState) {
          this.state = JSON.parse(decodedState);
        }
        
        this.email = searchParams['email'];
        this.appleUserID = searchParams['appleUserID'];

        //Check if the data coming from Apple is complete
        if(!this.state || !this.email || !this.appleUserID || status != "success") {
          this.errorMessage = "couldNotLogin";
          return;
        }

        if(this.state.changeToApple) {
          this.authService.changeProviderToApple(Global.getCountry(), this.appleUserID, this.email,
          StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe(res => {
            if (res && res["status"] === "success") {
              this.authService.loginByApple(Global.getCountry(), this.appleUserID, this.email).subscribe(res => {
                this.handleResult(res);
              }, err => {
                console.error(err);
                this.errorMessage = "couldNotLogin";
              });
            }
            else {
              this.errorMessage = "couldNotLogin";
            }
          }, err => {
            console.error(err);
            this.errorMessage = "couldNotLogin";
          });
        }
        else {

          //Check if the user already has another type of account
          this.authService.doesAccountExist(this.email, Global.getCountry()).subscribe(res => {
            if(res && res['status'] == 'success') {

              if(res['provider'] == 'standard') {
                this.errorMessage = "shouldLoginWithStandard";
              }
              else if(res['provider'] == 'facebook') {
                this.errorMessage = "shouldLoginWithFacebook";
              }
              else if(res['provider'] == 'apple') {
                this.authService.loginByApple(Global.getCountry(), this.appleUserID, this.email).subscribe(res => {
                  this.handleResult(res);
                }, err => {
                  this.errorMessage = "couldNotLogin";
                });
              }

            }
            else {
              //select username
              this.showUsernameForm = true;
            }
          }, err => {
            console.error(err);
            this.errorMessage = "couldNotLogin";
          });
        }

      }
      else {
        this.errorMessage = "couldNotLogin";
      }

    });

  }

  getQueryParams(data:string) {
    if(!data) {
      return {};
    }
    var queryParams = data.split('&').reduce(function (q, query) {
      var chunks = query.split('=');
      var key = chunks[0];
      var value = chunks[1];
      return (q[key] = value, q);
    }, {});
    return queryParams;
  }

  register(username: string) {
    this.showUsernameForm = false;
    this.authService.registerByApple(Global.getCountry(), this.appleUserID, this.email, username).subscribe(res => {
      if(res && res['status'] == 'success') {
        this.authService.loginByApple(Global.getCountry(), this.appleUserID, this.email).subscribe(res => {
          this.handleResult(res);
        }, err => {
          console.error(err);
          this.errorMessage = "couldNotLogin";
        });
        
      }
      else {
        this.errorMessage = "couldNotLogin";
      }
    }, err => {
      console.error(err);
      this.errorMessage = "couldNotLogin";
    });
  }

  handleResult(result) {
    if (result && result.status === "success" && result.additionalInfo) {
      StorageHelper.getInstance().save(StorageHelper.keys.email, this.email);
      StorageHelper.getInstance().save(StorageHelper.keys.sessionToken, result.additionalInfo.sessionToken);
      StorageHelper.getInstance().save(StorageHelper.keys.username, result.additionalInfo.username);
      StorageHelper.getInstance().save(StorageHelper.keys.profileImageUrl, result.additionalInfo.profileImageUrl);
      StorageHelper.getInstance().save(StorageHelper.keys.uniqueCustomerId, result.additionalInfo.uniqueCustomerId);
      this.authService.setIsLoggedIn(true);
      LoginHelper.getInstance().loginChanged(true);
      this.router.navigate([new URL(this.state.url).pathname], {replaceUrl:true});
    }
    else {
      this.errorMessage = result && result.message? result.message : "couldNotLogin";
    }
  }

}